/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      cognitoID
      name
      mail
      phone
      pass
      role
      comName
      comAddress
      comUnit
      comMail
      comPhone
      gate
      pSpot
      pNumber
      pNumGuest
      pAdmin
      pHandcap
      pSystem
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        cognitoID
        name
        mail
        phone
        pass
        role
        comName
        comAddress
        comUnit
        comMail
        comPhone
        gate
        pSpot
        pNumber
        pNumGuest
        pAdmin
        pHandcap
        pSystem
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTenant = /* GraphQL */ `
  query GetTenant($id: ID!) {
    getTenant(id: $id) {
      id
      name
      email
      carMake
      carModel
      licensePlate
      carMake2
      carModel2
      licensePlate2
      Apartment
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTenants = /* GraphQL */ `
  query ListTenants(
    $filter: ModelTenantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTenants(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        email
        carMake
        carModel
        licensePlate
        carMake2
        carModel2
        licensePlate2
        Apartment
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getGuest = /* GraphQL */ `
  query GetGuest($id: ID!) {
    getGuest(id: $id) {
      id
      name
      email
      carMake
      carModel
      licensePlate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listGuests = /* GraphQL */ `
  query ListGuests(
    $filter: ModelGuestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGuests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        email
        carMake
        carModel
        licensePlate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;


export const CheckIfEmailExists = `
  query CheckIfEmailExists($email: String) {
    listUsers(filter: {
      mail: {
        eq: $email
      }
    }) {
      items {
        id
        mail
      }
    }
  }
`;